export enum HierarchyType {
  CHURCH = 'church',
  ADMINISTRATIVE = 'administrative'
}

export interface OrganizationalUnit {
  readonly id: string;
  readonly name: string;
  readonly type: string;
  readonly hierarchyType: string;
  readonly parent?: OrganizationalUnitRef;
}

export interface UpdateOrganizationalUnit {
  readonly id: string;
  readonly name: string;
  readonly type: string;
  readonly hierarchyType: string;
  readonly parentId?: string;
}

export interface OrganizationalUnitRef {
  readonly id: string;
  readonly name?: string;
  readonly type?: string;
}

export interface HierarchicalOrganizationalUnit {
  readonly id: string;
  readonly name: string;
  readonly type: string;
  readonly hierarchyType: string;
  readonly level: number;
  readonly namesPath: string[];
  readonly idsPath: string[];
}
